module.exports = __webpack_public_path__ + "static/img/app-slide-show4.e637d3b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/client/cjpublishing-tb-wgm/images/app-slide-show4.png
// module id = gixd
// module chunks = 44